import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { useState as u, useEffect as p, Children as h, cloneElement as x } from "react";
import { createPortal as g } from "react-dom";
import { tv as w } from "tailwind-variants";
import m from "../Card.js";
import y from "../CheckboxInput.js";
import v from "../Icon.js";
import { H as N } from "./index-UjijAVoZ.js";
const i = ({ children: o, ...r }) => /* @__PURE__ */ t(N, { level: "4", tagName: "h2", ...r, children: o });
i.displayName = "Modal.Heading";
const b = w({
  base: [
    "bg-neutral-50",
    "flex",
    "flex-col",
    "gap-4",
    "max-w-[theme(containerWidth.sm)]",
    "p-5",
    "overflow-x-hidden",
    "overflow-y-auto",
    "w-full"
  ]
}), C = ({ children: o, className: r, dismissableId: l, modal: a }) => {
  const [c, f] = u();
  p(() => {
    f(!0);
  }, []);
  const d = (e) => {
    e ? document.cookie = `${l}=1` : document.cookie = `${l}=;expires=${(/* @__PURE__ */ new Date(
      0
    )).toUTCString()}`;
  };
  return c ? g(
    /* @__PURE__ */ n(
      "div",
      {
        ...a.attr.container,
        className: "bottom-0 fixed flex items-center justify-center left-0 right-0 top-0 z-40 aria-hidden:hidden",
        children: [
          /* @__PURE__ */ t(
            "div",
            {
              ...a.attr.overlay,
              className: "absolute bg-[hsla(0,100%,0%,0.8)] h-full w-full"
            }
          ),
          /* @__PURE__ */ n("div", { className: "w-full", role: "document", children: [
            /* @__PURE__ */ n("div", { className: "flex flex-col gap-4 items-center max-h-[80vh] px-5 py-6 overflow-auto w-full", children: [
              /* @__PURE__ */ t(m, { className: b({ class: r }), children: h.map(o, (e) => {
                var s;
                return ((s = e == null ? void 0 : e.type) == null ? void 0 : s.displayName) === "Modal.Heading" ? x(e, { ...a.attr.title }) : e;
              }) }),
              l && /* @__PURE__ */ t(m, { className: "flex justify-center max-w-[theme(containerWidth.sm)] px-5 py-4", children: /* @__PURE__ */ t(
                y,
                {
                  label: "Don’t show this message again",
                  name: "dismiss",
                  onChange: d
                }
              ) })
            ] }),
            /* @__PURE__ */ t(
              "button",
              {
                ...a.attr.closeButton,
                "aria-label": "Close modal",
                className: "absolute bg-white flex items-center h-[3.25rem] justify-center right-4 rounded-full top-4 w-[3.25rem]",
                children: /* @__PURE__ */ t(v, { className: "text-3xl", name: "xmark" })
              }
            )
          ] })
        ]
      }
    ),
    document.getElementById("modal-root")
  ) : null;
};
C.Heading = i;
export {
  C as M
};
